/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { UserProfileContext } from 'auth/contexts/UserProfileContext';

import { SEARCH_REDUCERS } from 'state/reducers/search/searchReducers';
import { AUTOCOMPLETE_REDUCERS } from 'state/reducers/autocomplete/autocompleteReducers';

import { tagTokenPrefix } from 'state/services/searchApiUtils';
import PatientSearchField from 'views/components/Search/PatientSearchField';
import PatientSearchForm from './KardiaRxSearchForm';
import {
  searchSubmit,
  getKardiaRxPatientsData,
} from '../../state/kardiaRxIdtf/KardiaRxIDTFPatientsActions';

import styles from './KardiaRxSearchBar.css';

class KardiaRxSearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchType: '',
      searchParams: {
        page: 1,
      },
      tagRemoved: null,
    };
  }

  handleSearchTypeChange = searchType => {};

  handleSubmit = values => {
    console.log("values", values);
    if (values && values.patients) {
      const valueArray = values.patients.split(' [');
      const mrnIdentifier =
        valueArray[1] && valueArray[1].substring(0, valueArray[1].length - 1);
      if (mrnIdentifier) {
        const mrnValue = mrnIdentifier.split(':')[1];
        this.props.getKardiaRxPatientsData(false, 249, 1, mrnValue, 'mrn');
      } else {
        this.props.getKardiaRxPatientsData(false, 249, 1, values.patients, 'identifier');
      }
    } else {
      this.props.getKardiaRxPatientsData();
    }
    this.props.handleSetPageToDefault();
    this.props.searchSubmit(values);
  };

  handleRemoveTag = (field, value) => {
    // console.log('hello Remove');
    this.props.handleSetPageToDefault();
    this.props.getKardiaRxPatientsData();
    // this.setState({
    //   tagRemoved: { field: value },
    // });
    // this.props.changeFieldValue(field, value);
    // this.props.dispatch(formSubmit(SEARCH_FORM_REDUCERS.PATIENT_SEARCH));
  };

  // eslint-disable-next-line no-unused-vars
  onFormChange = (values, previousValues) => {};

  render() {
    const { searchType, searchParams } = this.state;
    const { patientSearchResults, autocompleteResults } = this.props;
    // const { participants } = autocompleteResults;
    const autocompleteLoading = autocompleteResults.isFetching === true;
    return (
      <div className={styles.patientSearchBar}>
        <PatientSearchForm
          onFormChange={this.onFormChange}
          selectedSearchType={searchType}
          selectedOptionValues={this.props.selectedOptionValues}
          styles={styles}
          isSubmitting={patientSearchResults.isFetching === true}
          onSubmit={this.handleSubmit}
          onSearchTypeChange={this.handleSearchTypeChange}
          searchFieldComponent={
            <PatientSearchField
              placeholder="Patient name / MRN"
              isLoading={autocompleteLoading}
              autocompleteData={autocompleteResults}
              styles={styles}
              defaultValue={searchParams.patients}
              tokenPrefix={tagTokenPrefix}
              onRemoveTag={this.handleRemoveTag}
            />
          }
        />
      </div>
    );
  }
}
KardiaRxSearchBar.contextType = UserProfileContext;

// setup up redux search store
const mapStateToProps = ({ search, autocomplete, kardiaRx }) => {
  return {
    patientSearchResults: search[SEARCH_REDUCERS.INFINITE_SCROLL_REDUCER],
    autocompleteResults:
      kardiaRx.kardiaRxIDTFPatients.kardiaRxAutoCompleteSearch,
    autocompleteForceRefresh:
      autocomplete[AUTOCOMPLETE_REDUCERS.AUTOCOMPLETE_FORCE_REFRESH],
    selectedOptionValues: kardiaRx.kardiaRxIDTFPatients.filterDropdownlist.data,
  };
};

export default withRouter(
  connect(mapStateToProps, { searchSubmit, getKardiaRxPatientsData })(
    KardiaRxSearchBar,
  ),
);



// WEBPACK FOOTER //
// ./src/views/containers/KardiaRxSearch/KardiaRxSearchBar.jsx